import { render, staticRenderFns } from "./DictionaryItemForm.vue?vue&type=template&id=5e671df6&scoped=true"
import script from "./DictionaryItemForm.vue?vue&type=script&lang=js"
export * from "./DictionaryItemForm.vue?vue&type=script&lang=js"
import style0 from "./DictionaryItemForm.vue?vue&type=style&index=0&id=5e671df6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e671df6",
  null
  
)

export default component.exports